import React, {Fragment} from 'react'
import NavDesktop from './components/NavDesktop'
// import Sidebar from './components/Sidebar'

import './styles/_navbar.scss';
export default function Navbar({}) {
  return (
    <Fragment>
        <NavDesktop  />
        {/* <Sidebar data={data}/>  */}
    </Fragment>
  )
}

 